<template>
  <div class="online-container">
    <!-- 表格区域 -->
    <div class="table">
      <el-table ref="tableRef" :data="onlineUserList" v-loading="tableLoading" stripe border>
        <el-table-column type="index" label="序号" width="60" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="account" label="账号" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="nickName" label="昵称" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="lastLoginIp" label="最后登录IP" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="lastLoginTime" label="最后登录时间" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="lastLoginAddress" label="最后登录地址" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="lastLoginBrowser" label="最后登录浏览器" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="lastLoginOs" label="最后登录所用系统" align="center" :resizable="false"></el-table-column>
        <el-table-column label="操作" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" content="强制下线" placement="top">
              <i class="iconfont iconcaozuo-3qiangzhixiaxian_1" @click="handleClick(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import onlineApi from 'api/home/users-online.js';

export default {
  data() {
    return {
      total: 0,
      queryForm: {
        pageNo: 1,
        pageSize: 10
      },
      tableLoading: true,
      onlineUserList: []
    };
  },
  created() {
    this.getOnlineUserListData();
  },
  mounted() {},
  methods: {
    // 获取在线用户列表
    getOnlineUserListData() {
      this.tableLoading = true;
      onlineApi
        .getOnlineUserList(this.queryForm)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.totalRows;
            this.onlineUserList = res.data.data.rows;
          }
          // else {
          //   this.$message.error(res.data.message);
          //   this.tableLoading = false;
          // }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 点击强制下线
    handleClick(row) {
      this.$confirm('将强制下线该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.handleForceLogout(row.sessionId);
        })
        .catch(() => {});
    },
    // 强制下线
    handleForceLogout(sessionId) {
      onlineApi.postForceLogout({ sessionId }).then(res => {
        if (res.data.code === 200) {
          this.queryForm.pageNo = 1;
          this.queryForm.pageSize = 10;
          this.getOnlineUserListData();
          this.$message({
            message: '强制下线成功',
            type: 'success'
          });
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.getOnlineUserListData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getOnlineUserListData();
    }
  }
};
</script>

<style lang="less" scoped>
.online-container {
  padding: 16px;

  .page {
    margin: 16px 0;
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
